import { configureStore, combineReducers } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import todoReducer from "./todoSlice";
import themeReducer from "./themeSlice";
import socketReducer from "./socketSlice";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ['user', 'theme'], 
  blacklist: ['socket'], 
};

const rootReducer = combineReducers({
  user: userReducer,
  theme: themeReducer,
  todo: todoReducer,
  socket: socketReducer,
  // menu: menuReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          'socket/connectSocket',
          'socket/disconnectSocket'
        ],
        ignoredPaths: ['socket.socket'],
      },
    }),
});

export const persistor = persistStore(store);
